export const updateClone = (origin, field, value) => {
    const clone = {...origin};

    clone[field] = value;

    return clone;
};
